/**
 * Build https://wa.me links for AI Sales quick-send (no new pricing logic).
 * @param {string|null|undefined} phone
 * @returns {string} digits only, suitable for wa.me; "" if unusable
 */
export function sanitizeWhatsAppPhone(phone) {
  if (phone == null) return "";
  const raw = String(phone).trim();
  if (!raw) return "";
  let d = raw.replace(/\D/g, "");
  if (!d) return "";
  if (d.startsWith("972")) return d;
  if (d.startsWith("0") && d.length >= 9 && d.length <= 11) {
    return `972${d.slice(1)}`;
  }
  if (d.startsWith("5") && d.length >= 8 && d.length <= 10) {
    return `972${d}`;
  }
  if (d.length >= 8 && d.length <= 15) return d;
  return "";
}

/**
 * Open a WhatsApp chat (CRM / click-to-chat). Message is optional.
 * @param {string|null|undefined} phone
 * @param {string|null|undefined} [message]
 * @returns {string|null} full wa.me URL or null if phone unusable
 */
export function buildWhatsAppChatUrl(phone, message) {
  const n = sanitizeWhatsAppPhone(phone);
  if (!n) return null;
  const text = message == null ? "" : String(message).trim();
  if (!text) return `https://wa.me/${n}`;
  return `https://wa.me/${n}?text=${encodeURIComponent(text)}`;
}

/**
 * @param {string|null|undefined} phone
 * @param {string|null|undefined} message
 * @returns {string|null} full wa.me URL or null if should not open
 */
export function buildWhatsAppMeUrl(phone, message) {
  const text = message == null ? "" : String(message).trim();
  if (!text) return null;
  const n = sanitizeWhatsAppPhone(phone);
  if (!n) return null;
  return `https://wa.me/${n}?text=${encodeURIComponent(text)}`;
}

/**
 * שיתוף טקסט/קישור בוואטסאפ (בחירת איש קשר על ידי המשתמש).
 * @param {string|null|undefined} message
 * @returns {string|null}
 */
export function buildWhatsAppShareUrl(message) {
  const text = message == null ? "" : String(message).trim();
  if (!text) return null;
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

/**
 * הודעת שיתוף להצעת מחיר ללקוח (?offer=1).
 * @param {{ greetingName?: string, hotelName?: string, offerNumber?: string, shareUrl?: string, priceLabel?: string }} params
 */
export function buildCustomerOfferWhatsAppShareMessage(params = {}) {
  const lines = [];
  const name = params.greetingName != null ? String(params.greetingName).trim() : "";
  if (name) {
    lines.push(`שלום ${name},`);
    lines.push("");
  }
  lines.push("מצורפת הצעת מחיר לחבילת נופש:");
  const hotel = params.hotelName != null ? String(params.hotelName).trim() : "";
  if (hotel) lines.push(hotel);
  const offerNo = params.offerNumber != null ? String(params.offerNumber).trim() : "";
  if (offerNo) lines.push(`מספר הצעה: ${offerNo}`);
  const price = params.priceLabel != null ? String(params.priceLabel).trim() : "";
  if (price) lines.push(`מחיר: ${price}`);
  const url = params.shareUrl != null ? String(params.shareUrl).trim() : "";
  if (url) {
    lines.push("");
    lines.push(url);
  }
  return lines.join("\n").trim();
}
